@if (state?.results?.hits; as hitsUnordered) {
  @if (objectIDOrder ? (hitsUnordered | orderByObjectIDs : objectIDOrder) : hitsUnordered; as hits) {
    @for (product of hits | transformProductHit | enhanceProducts | async; track product; let i = $index; let last = $last) {
      @if (i | otherProductsGrid : last : hits.length | async; as className) {
        <app-other-products-card
          [product]="product"
          [className]="className"
          [index]="i + 1"
          [queryID]="$safeNavigationMigration(state?.results?.queryID)"
        ></app-other-products-card>
      }
    }
  }
}
